export default __webpack_public_path__ + "static/media/cloud1.3b786db1.png";